/**
 * @file AuthPage.tsx
 * @module app/modules/auth/AuthPage
 * @description Defines the AuthPage route, layout, or workflow for UTrade Admin authentication and session management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { Route, Routes } from 'react-router-dom';
import { ForgotPassword } from './components/forgot-password';
import { CreatePassword } from './components/create-password';
import { Login } from './components/login';
import { AuthLayout } from './AuthLayout';
import VerifyOTP from './components/verify-otp';
import VerifyPassword from './components/VerifyPassword';
const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route
        path="login"
        element={<Login />}
      />
      <Route
        index
        element={<Login />}
      />
    </Route>
    <Route
      path="forgot-password"
      element={<ForgotPassword />}
    />
    <Route
      path="create-password"
      element={<CreatePassword />}
    />
    <Route
      path="verify-password"
      element={<VerifyPassword />}
    />
  </Routes>
);
export { AuthPage };
